import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { switchMap, map } from 'rxjs/operators';
import { AddItems, UpdateFeedList, FetchFeedList, FetchItems, ClearItems } from './news.actions';
import { NewsService, INewsFeedItem, INewsFeedSourceName } from '../../pages/home/news/news.service';
import { forkJoin } from 'rxjs';

@Injectable()
export class NewsEffects {
  private actions$ = inject(Actions);
  private newsService = inject(NewsService);

  fetchFeedList$ = createEffect(() => this.actions$.pipe(
    ofType(FetchFeedList),
    switchMap(() => this.newsService.feeds().pipe(
        map((feeds: { [key: string]: INewsFeedSourceName }) => UpdateFeedList({ feeds }))
      ))
  ));

  fetchItems$ = createEffect(() => this.actions$.pipe(
    ofType(FetchItems),
    switchMap((activeFeeds: { feedIds: string[] }) => {
      const feedMap = {};
      for (const feedId of activeFeeds.feedIds) {
        feedMap[feedId] = this.newsService.items(feedId);
      }

      return forkJoin(feedMap).pipe(map((feedItemsMap: { [key: string]: INewsFeedItem[] }) => AddItems({ items: feedItemsMap })));
    })
  ));

  clearItems$ = createEffect(() => this.actions$.pipe(
    ofType(ClearItems),
    map((activeFeeds: { feedIds: string[] }) => {
      return FetchItems({ feedIds: activeFeeds.feedIds });
    })
  ));
}
